import { Injectable } from '@angular/core';
import { CognitoAuthService } from '@auth/services/cognito-auth.service';
import { map } from 'rxjs/operators';
import Auth, { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import { AgencyNode, UserAuthGQL } from '@app/generated/graphql';
import { Hub } from '@aws-amplify/core';
import { FetchPolicy } from '@apollo/client/core';

@Injectable({
  providedIn: 'root',
})
export class RdrAuthService {
  constructor(
    private userAuthGql: UserAuthGQL,
    private cognitoAuthService: CognitoAuthService,
  ) {
    Hub.listen('auth', ({ payload: { event, data } }) => {
      switch (event) {
        case 'customOAuthState':
          if (data) {
            window.location = data;
          }
          break;
      }
    });
  }

  amplifyLogin(redirectUrl: string) {
    return Auth.federatedSignIn({
      provider: CognitoHostedUIIdentityProvider.Google,
      customState: redirectUrl,
    });
  }

  getUser(fetchPolicy: FetchPolicy = 'cache-first') {
    return this.userAuthGql
      .fetch(
        {},
        {
          fetchPolicy,
        },
      )
      .pipe(
        map((el) => {
          // fixme: such a mess
          this.cognitoAuthService.user.id = el.data?.userAuth?.id || '';
          this.cognitoAuthService.user.email = el.data?.userAuth?.email;
          this.cognitoAuthService.user.fullName = el.data?.userAuth?.fullName;
          this.cognitoAuthService.user.picture = el.data?.userAuth?.picture;
          this.cognitoAuthService.user.isActive = el.data?.userAuth?.isActive;
          this.cognitoAuthService.user.superadmin = el.data?.userAuth?.superadmin;
          this.cognitoAuthService.user.isDev = el.data?.userAuth?.isDev;
          this.cognitoAuthService.user.isSuperadminContext = el.data?.userAuth?.isSuperadminContext;
          this.cognitoAuthService.user.profile = el.data?.userAuth?.profile;
          this.cognitoAuthService.user.authorizedInRc = el.data?.userAuth?.authorizedInRc;
          this.cognitoAuthService.user.ringCentralClientId = el.data?.userAuth?.ringCentralClientId;
          this.cognitoAuthService.user.agency = el.data?.userAuth
            ?.agency as unknown as Partial<AgencyNode>;

          return el.data.userAuth;
        }),
      );
  }
}
